window.okeReviewsWidgetOnInit = function () {
    setupReviewsWidgetHeader();
  	setupReviewsWidgetSelect();
};

function setupReviewsWidgetHeader() {
    const writeAReview = document.querySelector('.js-okeReviews-writeReview');
    const controlSort = document.querySelector('.okeReviews-reviews-controls-sort');

    // Move Write a Review Button beside Control Sort
    if(writeAReview && controlSort) {
        controlSort.insertAdjacentElement('beforeend', writeAReview);
    }
}

function setupReviewsWidgetSelect() {
    const widgetSelect = document.querySelector('.js-okeReviews-select');
    const filterToggle = document.querySelector('.okeReviews-reviews-controls-filterToggle');

    // Move Select inside Filter Toggle div
    if(widgetSelect && filterToggle) {
        filterToggle.insertAdjacentElement('beforeend', widgetSelect);
    }
}